import React, { Suspense, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProfileForm from '@/components/Profile/ProfileForm';
import { updateUserProfile } from './function';
import { message } from 'antd';
import Spinner from '@/components/Spinner';

interface ProfileContextType {
  user: {
    fullname: string;
    email: string;
    phone?: string;
    gender?: number;
    birthday?: string;
    job_title?: string;
    avatar_url?: string;
  };
}

const EditProfileTab: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useOutletContext<ProfileContextType>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: any) => {
    setLoading(true);
    try {
      await updateUserProfile(data);
    } catch (error) {
      message.error(t('adminProfile.updateError', 'An error occurred while updating profile.'));
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  return (
    <Suspense fallback={<Spinner />}>
      <ProfileForm
        initialData={user}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </Suspense>
  );
};

export default EditProfileTab;
